/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LaborActivityDtoPage } from '../../models/labor-activity-dto-page';

export interface ListLaborActivities$Params {
  query?: string;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'name' | '-name' | 'description' | '-description' | 'isDefault' | '-isDefault' | 'isActive' | '-isActive' | 'position' | '-position' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listLaborActivities(http: HttpClient, rootUrl: string, params?: ListLaborActivities$Params, context?: HttpContext): Observable<StrictHttpResponse<LaborActivityDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listLaborActivities.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LaborActivityDtoPage>;
    })
  );
}

listLaborActivities.PATH = '/v0/laborActivities';
